import React from 'react';
import { CareerAttributes } from '@app/models/dtos/strapi';
import Layout from '@app/layouts/_layout';
import Button from '@app/components/ui/button';
import ImageRenderer from '@app/components/media-renderer/image-renderer';
import environments from '@app/configs/environments';
import Item from '@app/components/item';
import { useRouter } from 'next/router';
import RadialGradient from '@app/components/ui/radial-gradient';
import { ILayoutProps } from '@app/models/props/home';

export interface ICareerProps extends ILayoutProps {
    career: CareerAttributes;
}

function Career({ locations, settings, career, products, socialMedias }: ICareerProps) {
    const router = useRouter();
    return (
        <Layout locations={locations} settings={settings} products={products} socialMedias={socialMedias} childClassName="py-[60px] flex w-full flex-col items-center md:py-[160px]">
            <RadialGradient />
            <div className="container w-full">
                <p className="P2 !text-black-1 ">Career</p>
                <p className="h2-responsive my-2 max-w-[786px] text-black-1 md:my-6" dangerouslySetInnerHTML={{ __html: career.title }}></p>
                <p className="P1 max-w-[384px] !text-black-2">{career.description}</p>
                <div className="mt-10">
                    <Button onClick={() => router.push('/career/openings')} size="large">
                        See Current Openings
                    </Button>
                </div>
            </div>
            {career.featureImage && (
                <div className="mt-[80px] aspect-banner-mobile w-full overflow-hidden bg-blue-opacity lg:aspect-banner-desktop">
                    <ImageRenderer media={environments.STRAPI_HOST_URL + career.featureImage.url} />
                </div>
            )}
            <div className="container w-full">
                {career.benifits && career.benifits.length !== 0 && (
                    <div className="mt-[80px] flex w-full flex-col md:mt-[160px]">
                        <p className="P2  !text-black-1 ">Benifits of Working With Us</p>
                        <div className="mt-[20px] grid grid-flow-row grid-cols-1 gap-[45px] sm:grid-cols-2 md:mt-[40px] lg:grid-cols-3">
                            {career.benifits.map((item) => (
                                <Item key={item.id} item={item} />
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
}

export { getServerSideCareerProps as getServerSideProps } from '@app/lib/serverSideProps';
export default Career;
